module.exports = __webpack_public_path__ + "img/app4.7e2f9f18.png";